import Vue from 'vue';
import Truncate from 'lodash.truncate';

Vue.filter('truncate', Truncate);

Vue.filter('statusPedido', status => ['AGUARDANDO CONFIRMAÇÃO', 'AGUARDANDO ENTREGA', 'ENTREGA NOTIFICADA', 'CANCELADO', 'CONCLUÍDO'][status]);

Vue.filter('mod', val => val * -1);

Vue.filter('turnos', val => {
  // val == '1,2' ? 'Sempre disponível' : `Disponível apenas no turno ${val}`
  if(val.turno1 == 1 && val.turno2 == 1) return 'Sempre disponível';
  else if(val.turno1 == 1 && val.turno2 == 0) return 'Disponível apenas no turno 1';
  else if(val.turno1 == 0 && val.turno2 == 1) return 'Disponível apenas no turno 2';
});

Vue.filter('disponibilidade', val => _.filter(_.map(['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'], (o, i) => val.toString().indexOf(i) > -1 ? o : null), o => o !== null).toString().replace(/,/g, ' | '));

Vue.filter('telefone', pedido => {
  let text = "";
  if(pedido.usuario && pedido.usuario.ddd &&  pedido.usuario.ddd !== '' && pedido.usuario.telefone && pedido.usuario.telefone !== ''){
    text += pedido.usuario.ddd ? '('+pedido.usuario.ddd+')' : "";
    text += pedido.usuario.telefone ? pedido.usuario.telefone.length == 8 ? " " + pedido.usuario.telefone.substring(0,4) + "-" + pedido.usuario.telefone.substring(4) : " " +pedido.usuario.telefone.substring(0,5) + "-" + pedido.usuario.telefone.substring(5) : "";
  }else{
    text += pedido.endereco.ddd ? '('+pedido.endereco.ddd+')' : "";
    text += pedido.endereco.telefone ? pedido.endereco.telefone.length == 8 ? " " + pedido.endereco.telefone.substring(0,4) + "-" + pedido.endereco.telefone.substring(4) : " " + pedido.endereco.telefone.substring(0,5) + "-" + pedido.endereco.telefone.substring(5) : "";
  }
  return text;
});

Vue.filter('removeAccents', s => {
  let r = s ? s.toLowerCase() : "";
  // r = r.replace(new RegExp('\\s', 'g'), '');
  r = r.replace(new RegExp('[àáâãäå]', 'g'), 'a');
  r = r.replace(new RegExp('æ', 'g'), 'ae');
  r = r.replace(new RegExp('ç', 'g'), 'c');
  r = r.replace(new RegExp('[èéêë]', 'g'), 'e');
  r = r.replace(new RegExp('[ìíîï]', 'g'), 'i');
  r = r.replace(new RegExp('ñ', 'g'), 'n');
  r = r.replace(new RegExp('[òóôõö]', 'g'), 'o');
  r = r.replace(new RegExp('œ', 'g'), 'oe');
  r = r.replace(new RegExp('[ùúûü]', 'g'), 'u');
  r = r.replace(new RegExp('[ýÿ]', 'g'), 'y');
  // r = r.replace(new RegExp('\\W', 'g'), '');
  r = r.replace('\'', '');
  r = r.replace('´', "'");
  r = r.replace('`', "'");
  r = r.replace('’', "'");

  return r;
});

Vue.filter('endereco', endereco => {
  let text = endereco.logradouro;
  text += endereco.numero ? ", "+endereco.numero : "";
  text += (endereco.complemento && endereco.complemento.trim() !== "") ? " - "+endereco.complemento : "";
  text += endereco.bairro ? " - "+endereco.bairro : "";
  return text;
});

Vue.filter('number', value => {
  return Number(value || 0).toLocaleString('pt-BR');
});

export default Vue;
